<template>    
    <v-combobox     
    :loading="loading" 
    label="Party" 
    :items="lookup"
    :value="value"
    @input="emit" 
    solo flat 
    >
    </v-combobox>           
</template>
<script>
import axios from 'axios'
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    props: ['value'],
    created() {
        this.query();
    },
    data() {
        return ({
            loading: true,
            lookup: []
        });
    },
    methods: {
        emit($event) {
            this.$emit('input', $event);
        },
        query() {
            axios.get(`/api/divisionsSearch/parties`)
                .then(response => {
                    this.lookup = response
                        .data;
                    this.loading = false;
                });
        },
    }
}
</script>